import { makeStyles, Theme } from '@material-ui/core/styles';
import { colors } from 'theme/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    maxWidth: 384,
  },
  container: {
    marginTop: -20,
    marginBottom: -20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconBox: {
    marginBottom: theme.spacing(4),
    padding: '30px 40px 22px',
    width: 'fit-content',
    background: colors.BACKGROUND,
    borderRadius: '100%',
  },
  txt: {
    fontSize: 18,
    textAlign: 'center',
  },
}));
